import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevisionOld: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTelevisionOld"><Path d="M7.36818 2.19727L11.9996 5.7995L16.6311 2.19727L17.552 3.38129L14.1851 6H22V21H2V6H9.81417L6.44727 3.38129L7.36818 2.19727Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelevisionOld;
